"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.USER_ACTION_NAME = exports.USER_ACTION_LOCATION = exports.LANGUAGE_SELECTOR = void 0;
const LANGUAGE_SELECTOR = exports.LANGUAGE_SELECTOR = 'language-selector';
const USER_ACTION_NAME = exports.USER_ACTION_NAME = 'language_select';
const USER_ACTION_LOCATION = exports.USER_ACTION_LOCATION = 'footer';
